<template>
  <v-dialog v-model="dialog" width="800" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        :outlined="!$vuetify.breakpoint.xs"
        color="danger"
        v-bind="attrs"
        v-on="on"
      >
        {{
          $vuetify.breakpoint.xs
            ? ""
            : $vuetify.breakpoint.mobile
            ? "Meldung"
            : "Meldung häufiger Absenzen"
        }}
      </v-btn>
    </template>

    <v-card :loading="loading">
      <v-system-bar color="danger"
        >Meldung häufiger Absenzen verfassen</v-system-bar
      >
      <PersonItemBasic :value="overview.student"></PersonItemBasic>
      <v-card-text>
        Meldung an die Abteilungsleitung:

        <v-chip-group column>
          <v-chip color="error" outlined
            >offen: {{ overview.pendingLessons }}</v-chip
          >

          <v-chip color="success" outlined
            >entschuldigt: {{ overview.excusedLessons }}</v-chip
          >

          <v-chip color="danger" outlined
            >unentschuldigt: {{ overview.unexcusedLessons }}</v-chip
          >

          <v-chip color="primary" outlined
            >total:
            {{
              overview.pendingLessons +
              overview.excusedLessons +
              overview.unexcusedLessons
            }}</v-chip
          >
        </v-chip-group>

        <v-form>
          <v-checkbox
            v-model="repeatedViolation"
            label="Es sind wiederholt Verstösse gegen die Absenzenordnung
              aufgetreten."
          ></v-checkbox>
          <v-checkbox
            v-model="sumExceeds"
            label="Die Summe der gesamten Absenzen im Semester überschreitet ein
              Wochenpensum"
          ></v-checkbox>

          <v-textarea
            v-model="measures"
            outlined
            rows="5"
            label="Einordnung und bereits getroffene Massnahmen"
            hint="z.B.: Gespräch mit Schüler*in geführt, schriftliche Stellungnahme der Schüler*in eingeholt, Terminbestätigungen eingefordert, Arztzeugnisse abgelegt, andere pädagogische Massnahmen."
            persistent-hint
            persistent-placeholder
            required
          ></v-textarea>

          <v-checkbox
            v-model="parentsInformed"
            label="Eine Rücksprache mit den Eltern (gem. Art. 131 Abs. 5 MiSDV) ist
                erfolgt."
          ></v-checkbox>

          <v-textarea
            v-model="meetingTeacher"
            outlined
            rows="5"
            label="Datum des Elterngesprächs / Gesprächsnotiz"
            persistent-hint
            persistent-placeholder
            required
          ></v-textarea>

          <v-textarea
            v-model="application"
            outlined
            rows="5"
            label="Antrag der Klassenlehrkraft"
            :hint="'z.B.: ' + this.resolutions.join(', ')"
            persistent-hint
            persistent-placeholder
            required
          ></v-textarea>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn text @click="dialog = false">abbrechen </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="disabled || saving"
          :loading="saving"
          color="primary"
          text
          @click="save"
          >melden
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from "vue";
import PersonItemBasic from "common/components/PersonItemBasic.vue";
import resolutions from "common/components/Absences/frequentAbsencesResolutions.js";

export default defineComponent({
  components: { PersonItemBasic },
  props: ["id", "term"],

  data() {
    return {
      dialog: false,
      overview: {},
      loading: false,
      student: null,
      absences: [],
      repeatedViolation: false,
      parentsInformed: false,
      sumExceeds: false,
      application: "",
      meetingTeacher: "",
      measures: "",
      saving: false,
      resolutions: resolutions,
    };
  },
  watch: {
    dialog(newValue) {
      if (newValue) {
        this.fetchData();
      }
    },
  },
  computed: {
    disabled() {
      if (this.application.trim() === "" || this.measures.trim() === "") {
        return true;
      }
      return false;
    },
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.overview = await this.apiList({
        resource: "absence/overview",
        query: `student=${this.id}&term=${this.term}`,
      });

      this.loading = false;
    },
    async save() {
      if (
        await this.$root.confirm({
          message: `Soll diese Häufung von Absenzen gemeldet werden?`,
          color: "success",
          icon: "mdi-bed",
        })
      ) {
        this.saving = true;
        const data = {
          student: this.overview.student.id,
          pendingCount: this.overview.pendingLessons,
          excusedCount: this.overview.excusedLessons,
          unexcusedCount: this.overview.unexcusedLessons,
          repeatedViolation: this.repeatedViolation,
          parentsInformed: this.parentsInformed,
          application: this.application,
          meetingTeacher: this.meetingTeacher,
          measures: this.measures,
        };
        await this.apiPost({
          resource: "absence/frequentAbsences",
          data: data,
        });
        this.$emit("saved");
        this.$root.showSuccess("Erfolgreich gemeldet");
        this.saving = false;
        this.dialog = false;
      }
    },
  },
});
</script>
